import  ApiHelper from '../../ApiHelper';
import API_ENDPOINTS  from '../../endpoints';

/**
 * Authentication-related API requests
 */
class AuthenticationHelper {
    /**
     * User login with email/username and password
     * @param {Object} credentials - Login credentials
     * @param {string} credentials.identifier - Email or username
     * @param {string} credentials.password - User password
     * @returns {Promise<Object>} Login response with user data
     */
    async login(credentials) {
        try {
            const { identifier, password } = credentials;
            console.log("Login called with", identifier, password);
            const response = await ApiHelper.post(API_ENDPOINTS.AUTH.LOGIN, {
                identifier: identifier,
                password
            });

            

            return response;
        } catch (error) {
            throw new Error(`Login failed: ${error.message}`);
        }
    }

    /**
     * User logout - clears server cookies and local storage
     * @returns {Promise<Object>} Logout response
     */
    async logout() {
        try {
            const response = await ApiHelper.post(API_ENDPOINTS.AUTH.LOGOUT);
            
            
            return response;
        } catch (error) {
            // Even if server request fails, clear local data
            this.clearLocalUserData();
            throw new Error(`Logout failed: ${error.message}`);
        }
    }

    /**
     * Logout from all devices
     * @returns {Promise<Object>} Logout response
     */
    async logoutAll() {
        try {
            const response = await ApiHelper.post(API_ENDPOINTS.AUTH.LOGOUT_ALL);
            this.clearLocalUserData();
            return response;
        } catch (error) {
            this.clearLocalUserData();
            throw new Error(`Logout from all devices failed: ${error.message}`);
        }
    }

    /**
     * Refresh access token using refresh token cookie
     * @returns {Promise<Object>} Refresh response
     */
    async refreshToken() {
        try {
            // Server uses refresh token cookie automatically
            return await ApiHelper.post(API_ENDPOINTS.AUTH.REFRESH_TOKEN);
        } catch (error) {
            throw new Error(`Token refresh failed: ${error.message}`);
        }
    }

    /**
     * Check if user is currently authenticated
     * @returns {Promise<boolean>} Authentication status
     */
    async isAuthenticated() {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.AUTH.PROFILE);
            return response.success;
        } catch (error) {
            return false;
        }
    }

    /**
     * Get current user from local storage
     * @returns {Object|null} User data or null
     */
  async getProfile() {
        try {
            const response = await ApiHelper.get(API_ENDPOINTS.AUTH.PROFILE);
            return response;
        } catch (error) {
            return false;
        }
    }

    /**
     * Clear local user data
     * @private
     */
    clearLocalUserData() {
        sessionStorage.removeItem('user');
        localStorage.removeItem('userPreferences');
        localStorage.removeItem('lastLoginTime');
    }

    /**
     * Handle authentication errors globally
     * @param {Error} error - Authentication error
     * @returns {Object} Formatted error response
     */
    handleAuthError(error) {
        const authError = {
            type: 'AUTHENTICATION_ERROR',
            message: error.message,
            timestamp: new Date().toISOString()
        };

        // Log authentication errors for debugging
        console.error('Authentication Error:', authError);

        // Redirect to login for 401 errors
        if (error.status === 401) {
            window.location.href = '/auth/login';
        }

        return authError;
    }
}

export default new AuthenticationHelper();
